<form *ngIf="userForm" [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <div class="inputs-container">
        <div class="inline-wrapper">
            <div class="button-wrapper" *ngIf="profilId">
                <div class="button" (click)="goToFeaturesManagment()">Activation/Désactivation<br>des fonctionnalités du profil</div>
            </div>

            <div>
                <div class="user-container" *ngIf="!isAdminMode">
                    <!-- <frg-form-input *ngIf="(!isAdminMode && !this.route.snapshot.params.id) || isAdminMode"
                        label="N° RPPS" id="rpps" type="text" errorMessage="Veuillez renseigner le champ"
                        [formGroup]="userForm" [control]="userForm.get('rpps')" (modelChanged)="findInfoByRpps($event)">
                    </frg-form-input> -->
                  <label>
                      Administrateur Cabinet
                      <input type="checkbox" id="adminCabinet" [formControl]="userForm.get('adminCabinet')">
                      <span class="checkMark"></span>
                  </label>
                </div>
                <div class="user-container">
                    <frg-form-input *ngIf="(!isAdminMode && !this.route.snapshot.params.id) || isAdminMode"
                        label="Nom d'utilisateur" id="pseudo" type="text" errorMessage="Veuillez renseigner le champ"
                        [formGroup]="userForm" [control]="userForm.get('pseudo')" required="true">
                    </frg-form-input>
                    <label *ngIf="!isAdminMode">
                        Actif
                        <input type="checkbox" id="actif" [formControl]="userForm.get('actif')">
                        <span class="checkMark"></span>
                    </label>
                </div>
            </div>
        </div>
        <div *ngIf="!isAdminMode">
            <div class="form-line">
                <frg-form-input class="rpps-field" [disabled]="isRppsFromAnn || isInRppsSearching"
                    label="N° RPPS" id="rpps" type="text"
                    [formGroup]="userForm" [control]="userForm.get('rpps')">
                </frg-form-input>
                <frg-button [disabled]="!(userForm?.get('rpps')?.value) || isInRppsSearching" class="search-rpps" (activated)="findInfoByRpps()">Rechercher&nbsp;avec&nbsp;RPPS</frg-button>
            </div>
            <!-- <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.rpps">
                <div class="libelle">{{ rppsInfo && rppsInfo.rpps ? 'RPPS annuaire de santé : ' + rppsInfo.rpps : '' }}</div>
                <div class="button" (click)="useNewValue(userForm.get('rpps'), rppsInfo.rpps, 'rpps')">Utiliser&nbsp;cette&nbsp;valeur</div>
            </div> -->
            <!-- <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo">
                <input [value]="rppsInfo && rppsInfo.rpps ? 'RPPS annuaire de santé : ' + rppsInfo.rpps : ''" type="text" readonly="true">
            </div> -->
            <frg-form-input *ngIf="!isSecretary" label="Qualité" id="qualite" type="ngSelect" closeOnSelect="true" [selectValue]="qualiteValue"
                errorMessage="Veuillez renseigner le champ" [formGroup]="userForm" [control]="userForm.get('qualite')"
                required="true" [disabled]="isQualiteFromAnn">
            </frg-form-input>
            <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.profession">
                <div class="libelle">{{ rppsInfo && rppsInfo.profession ? 'Profession annuaire de santé : ' + rppsInfo.profession : '' }}</div>
                <div class="button" (click)="useNewValue(userForm.get('qualite'), rppsInfo.codeProfession, 'codeProfession')">Utiliser&nbsp;cette&nbsp;valeur</div>
            </div>
            <frg-form-input *ngIf="!isSecretary" label="Spécialité" id="specialite" type="ngSelect" closeOnSelect="true"
                [selectValue]="specialiteValue" errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
                [control]="userForm.get('specialite')" required="true" [disabled]="isSpecialiteFromAnn">
            </frg-form-input>
            <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.specialite">
                <div class="libelle">{{ rppsInfo && rppsInfo.specialite ? 'Spécialité annuaire de santé : ' + rppsInfo.specialite : '' }}</div>
                <div class="button" (click)="useNewValue(userForm.get('specialite'), rppsInfo.codeSpecialite, 'codeSpecialite')">Utiliser&nbsp;cette&nbsp;valeur</div>
            </div>
            <div class="profil-container">
                <p>Profil</p>
                <div class="profils" formArrayName="roles">
                    <label *ngFor="let role of rolesFormArray.controls; let i = index">
                        <input type="checkbox" [formControlName]="i">
                        {{ roles[i].nom }}
                        <span class="checkMark"></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-line">
            <frg-form-input label="Nom d'usage"
                id="nom" type="text" errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
                [control]="userForm.get('nom')" required="true" [disabled]="isNomFromAnn">
            </frg-form-input>
            <frg-button *ngIf="!isNomFromAnn" [disabled]="isInRppsSearching" class="search-rpps" (activated)="findRppsByNames()">Rechercher&nbsp;le&nbsp;RPPS</frg-button>
        </div>
        <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.nom">
            <div class="libelle">{{ rppsInfo && rppsInfo.nom ? 'Nom annuaire de santé : ' + rppsInfo.nom : '' }}</div>
            <div class="button" (click)="useNewValue(userForm.get('nom'), rppsInfo.nom, 'nom')">Utiliser&nbsp;cette&nbsp;valeur</div>
        </div>

        <frg-form-input label="Prénom"
            id="prenom" type="text" errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
            [control]="userForm.get('prenom')" required="true" [disabled]="isPrenomFromAnn">
        </frg-form-input>
        <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.prenom">
            <div class="libelle">{{ rppsInfo && rppsInfo.prenom ? 'Prénom annuaire de santé : ' +  rppsInfo.prenom : '' }}</div>
            <div class="button" (click)="useNewValue(userForm.get('prenom'), rppsInfo.prenom, 'prenom')">Utiliser&nbsp;cette&nbsp;valeur</div>
        </div>

        <div *ngIf="!isAdminMode">
            <frg-form-input label="Catégorie"
                id="categorie" type="ngSelect" [selectValue]="userCategories" errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
                [control]="userForm.get('categorie')" required="true" [disabled]="isCategorieFromAnn">
            </frg-form-input>
            <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.categorie">
                <div class="libelle">{{ rppsInfo && rppsInfo.categorie ? 'Catégorie annuaire de santé : ' +  rppsInfo.categorie : '' }}</div>
                <div class="button" (click)="useNewValue(userForm.get('categorie'), rppsInfo.categorie, 'categorie')">Utiliser&nbsp;cette&nbsp;valeur</div>
            </div>

            <frg-form-input label="Adresse" id="adresse" type="text" errorMessage="Veuillez renseigner le champ"
                [formGroup]="userForm" [control]="userForm.get('adresse')" required="true">
            </frg-form-input>
            <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.adresse">
                <div class="libelle">{{ rppsInfo && rppsInfo.adresse ? 'Adresse annuaire de santé : ' +   rppsInfo.adresse : '' }}</div>
                <div class="button" (click)="useNewValue(userForm.get('adresse'), rppsInfo.adresse, 'adresse')">Utiliser&nbsp;cette&nbsp;valeur</div>
            </div>
                <frg-form-input label="Code postal" id="codePostal" type="number"
                    errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
                    [control]="userForm.get('codePostal')" required="true">
                </frg-form-input>
                <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.codePostal">
                    <div class="libelle">{{ rppsInfo && rppsInfo.codePostal ? 'Code postal annuaire de santé : ' +   rppsInfo.codePostal : '' }}</div>
                    <div class="button" (click)="useNewValue(userForm.get('codePostal'), rppsInfo.codePostal, 'codePostal')">Utiliser&nbsp;cette&nbsp;valeur</div>
                </div>
                <frg-form-input label="Ville" id="ville" type="text" errorMessage="Veuillez renseigner le champ"
                    [formGroup]="userForm" [control]="userForm.get('ville')" required="true">
                </frg-form-input>
                <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.commune">
                    <div class="libelle">{{ rppsInfo && rppsInfo.commune ? 'Ville annuaire de santé : ' +   rppsInfo.commune : '' }}</div>
                    <div class="button" (click)="useNewValue(userForm.get('ville'), rppsInfo.commune, 'commune')">Utiliser&nbsp;cette&nbsp;valeur</div>
                </div>
        </div>
        <frg-form-input *ngIf="!isAdminMode" label="Numéro de téléphone" id="telephone" type="tel"
            errorMessage="Veuillez renseigner le champ" [formGroup]="userForm" [control]="userForm.get('telephone')">
        </frg-form-input>
        <!-- <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.telephone">
            <div class="libelle">{{ rppsInfo && rppsInfo.telephone ? 'Téléphone annuaire de santé : ' +   rppsInfo.telephone : '' }}</div>
            <div class="button" (click)="useNewValue(userForm.get('telephone'), rppsInfo.telephone, 'telephone')">Utiliser&nbsp;cette&nbsp;valeur</div>
        </div> -->
        <frg-form-input label="Adresse email"
            id="email" type="email" errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
            [control]="userForm.get('email')" required="true">
        </frg-form-input>
        <frg-form-input label="Adresse MSS"
            id="emailMss" type="text" errorMessage="Veuillez renseigner le champ" [formGroup]="userForm"
            [control]="userForm.get('emailMss')" [disabled]="isAdresseMssFromAnn">
        </frg-form-input>
        <!-- <input *ngIf="(!isAdminMode && !this.route.snapshot.params.id) || isAdminMode && rppsInfo" [value]="rppsInfo && rppsInfo.email ? 'Email annuaire de santé : ' +   rppsInfo.email : '' " type="text" readonly="true"> -->
        <div class="rpps-info" *ngIf="!isAdminMode && rppsInfo && rppsInfo.emailMSS">
            <div class="libelle">{{ rppsInfo && rppsInfo.emailMSS ? 'Mail MSS annuaire de santé : ' + rppsInfo.emailMSS : '' }}</div>
            <div class="button" (click)="useNewValue(userForm.get('emailMss'), rppsInfo.emailMSS, 'emailMSS')">Utiliser&nbsp;cette&nbsp;valeur</div>
        </div>
    </div>
    <div class="button-submit-container">
        <button type="submit" [disabled]="!userForm.valid">Sauvegarder</button>
    </div>
</form>

<div class="historique-cgu-wrapper" *ngIf="user">

    <div class="cgu-title">Historique de validation des CGU</div>

    <div class="cgu-button-wrapper">
        <div>Statut actuel : <b>{{ currentCgu?.decisionStateLabel ? currentCgu.decisionStateLabel : 'Inconnu' }}</b></div>
        <frg-button (activated)="unlockCguValidation()" [disabled]="currentCgu && (currentCgu.currentCguDecisionState === decisionStateEnum.ResetAdmin)">Reset validation</frg-button>
    </div>

    <table mat-table [dataSource]="historiqueCgu" class="mat-elevation-z8">

        <ng-container matColumnDef="cguVersion">
            <th mat-header-cell *matHeaderCellDef> Version </th>
            <td mat-cell *matCellDef="let cguState"> {{cguState.cguVersion}} </td>
        </ng-container>

        <ng-container matColumnDef="decisionDateStr">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let cguState"> {{cguState.decisionDateStr}} </td>
        </ng-container>

        <ng-container matColumnDef="decisionState">
            <th mat-header-cell *matHeaderCellDef> Statut </th>
            <td mat-cell *matCellDef="let cguState"> {{cguState.decisionStateLabel}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</div>